var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 662.343,
    height: 1918.033,
    viewBox: "0 0 662.343 1918.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    "data-name": "Group 2224",
    transform: "matrix(-0.174, -0.985, 0.985, -0.174, -26.452, 1339.187)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M-631.414,337.312S-384.2,226.9-205.246,252.95-96.092,441.518,84.417,441.518,329.589,244.831,516.789,252.95,648.451,470,833.22,473.992s422.644-205.074,422.644-205.074",
    transform: "translate(0.048 0)",
    fill: "none",
    stroke: "#0f8fe3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M-631.414,337.312S-384.2,226.9-205.246,252.95-96.092,441.518,84.417,441.518,329.589,244.831,516.789,252.95,648.451,470,833.22,473.992s422.644-205.074,422.644-205.074",
    transform: "translate(0.048 18.939)",
    fill: "none",
    stroke: "#0f8fe3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M-631.414,337.312S-384.2,226.9-205.246,252.95-96.092,441.518,84.417,441.518,329.589,244.831,516.789,252.95,648.451,470,833.22,473.992s422.644-205.074,422.644-205.074",
    transform: "translate(0.048 37.878)",
    fill: "none",
    stroke: "#0f8fe3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M-631.414,337.312S-384.2,226.9-205.246,252.95-96.092,441.518,84.417,441.518,329.589,244.831,516.789,252.95,648.451,470,833.22,473.992s422.644-205.074,422.644-205.074",
    transform: "translate(0.048 56.817)",
    fill: "none",
    stroke: "#0f8fe3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M-631.414,337.312S-384.2,226.9-205.246,252.95-96.092,441.518,84.417,441.518,329.589,244.831,516.789,252.95,648.451,470,833.22,473.992s422.644-205.074,422.644-205.074",
    transform: "translate(0.048 75.756)",
    fill: "none",
    stroke: "#0f8fe3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M-631.414,337.312S-384.2,226.9-205.246,252.95-96.092,441.518,84.417,441.518,329.589,244.831,516.789,252.95,648.451,470,833.22,473.992s422.644-205.074,422.644-205.074",
    transform: "translate(0.048 94.695)",
    fill: "none",
    stroke: "#0f8fe3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M-631.414,337.312S-384.2,226.9-205.246,252.95-96.092,441.518,84.417,441.518,329.589,244.831,516.789,252.95,648.451,470,833.22,473.992s422.644-205.074,422.644-205.074",
    transform: "translate(-0.036 113.493)",
    fill: "none",
    stroke: "#0f8fe3",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide);
export default __webpack_public_path__ + "static/media/Side.05eeff23899c83e8717dd55be5477c59.svg";
export { ForwardRef as ReactComponent };